<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">
      <!-- Brand logo-->
      <b-link class="brand-logo">
        <img width="10%" :src="require('@/assets/images/logo/playgol.svg')" alt="">
        <h3 class="brand-text text-primary ml-1 d-flex align-items-center" style="color:black !important">
          PLAYGOL
        </h3>
      </b-link>
      <!-- /Brand logo-->

      <!-- Left Text-->
      <b-col lg="8" class="d-none d-lg-flex align-items-center p-5">
        <div
          class="w-100 d-lg-flex align-items-center justify-content-center px-5"
        >
          <b-img fluid :src="imgUrl" alt="Forgot password V2" />
        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- Forgot password-->
      <b-col lg="4" class="d-flex align-items-center auth-bg px-2 p-lg-5">
        <b-col sm="8" md="6" lg="12" class="px-xl-2 mx-auto">
          <b-card-title title-tag="h2" class="font-weight-bold mb-1">
            Olvidaste tu contraseña? 🔒
          </b-card-title>
          <b-card-text class="mb-2">
            No te preocupes! Nos sucede a todos. <br />
            Ingrese su e-mail
          </b-card-text>

          <!-- form -->
          <validation-observer ref="simpleRules">
            <b-form
              class="auth-forgot-password-form mt-2"
              @submit.prevent="validationForm"
            >
              <b-form-group label="Email" label-for="forgot-password-email">
                <validation-provider
                  #default="{ errors }"
                  name="Email"
                  rules="required|email"
                >
                  <b-form-input
                    id="forgot-password-email"
                    v-model="userEmail"
                    :state="errors.length > 0 ? false : null"
                    name="forgot-password-email"
                    placeholder="john@example.com"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <b-button
                v-if="!showLoading"
                type="submit"
                variant="primary"
                block
              >
                Enviar
              </b-button>
              <div v-if="showLoading" class="text-center mt-1">
                <b-spinner variant="primary" label="Text Centered" />
              </div>
            </b-form>
          </validation-observer>

          <p class="text-center mt-2">
            <b-link :to="{ name: 'auth-login-v2' }">
              <feather-icon icon="ChevronLeftIcon" /> Regresar al login
            </b-link>
          </p>
        </b-col>
      </b-col>
      <!-- /Forgot password-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate'
// import VuexyLogo from '@core/layouts/components/Logo.vue'
import {
  BRow,
  BCol,
  BLink,
  BCardTitle,
  BCardText,
  BImg,
  BForm,
  BFormGroup,
  BFormInput,
  BButton,
  BSpinner,
  // BFormInvalidFeedback,
  // BFormValidFeedback,
} from 'bootstrap-vue'
import { required, email } from '@validations'
import store from '@/store/index'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import apiCall from '../utils/apiCall'
import {
  // setUser,
  URL,
  // USER,
  // xxxx
} from '../utils/variables'
// import { URL } from '../utils/variables.js'
// import axios from 'axios'

export default {
  components: {
    // VuexyLogo,
    BRow,
    BCol,
    BLink,
    BImg,
    BForm,
    BButton,
    BFormGroup,
    BFormInput,
    BCardTitle,
    BCardText,
    ValidationProvider,
    ValidationObserver,
    BSpinner,
    // BFormInvalidFeedback,
    // BFormValidFeedback,
  },
  data() {
    return {
      userEmail: '',
      userPass: '',
      tieneErrorNuevaC: null,
      mensajeErrorNombre: '',
      showLoading: false,
      sideImg: require('@/assets/images/pages/olvido2.svg'),
      // validation
      required,
      email,
      // newPassword,
    }
  },
  computed: {
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require('@/assets/images/pages/olvido2.svg')
        return this.sideImg
      }
      return this.sideImg
    },
  },
  methods: {
    validationForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          // this.signIn(this.userEmail, this.password)
          this.remember()
        }
      })
    },
    async remember() {
      // console.log(JSON.stringify(user))
      this.showLoading = true
      const { postApi } = apiCall()
      const path = 'ApiUsuario/sendUserMail/f/a/a/a/a/a'
      const dataDelete = {
        email: this.userEmail,
      }
      const data = await postApi(URL, path, dataDelete)
      this.showLoading = false
      // console.log(data)
      if (data.flag === 'si') {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'FELICIDADES',
            icon: 'AwardIcon',
            variant: 'success',
            text: 'Se ha enviado tus credenciales a tu correo electrónico!',
          },
        })
      } else {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'ERROR',
            icon: 'XOctagonIcon',
            variant: 'danger',
            text: data.mensaje,
          },
        })
      }
      //   const url = `${URL}ApiLogin/isLogin` // VARIABLE CREADA EN GLOBAL
      //   const resp = await axios
      //     .post(url, JSON.stringify(user))
      //     .then(response => response.data)
      //     .catch(() => null)
      //   // console.log(resp);
      //   return resp
      // },
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
